import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import ListaEspecialidades from "../ListaEspecialidades";
import {
  crearUsuario,
  getUsuarios,
  getPerfiles,
  getPermissions,
} from "../../utils/utils";
import { sections } from "../../utils/properties";

const Usuarios = ({ parentCallback, disabled }) => {
  const history = useHistory();
  let { id } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [usuarios, setUsuarios] = useState([]);
  const [perfiles, setPerfiles] = useState([]);
  const [perfil, setPerfil] = useState("A");
  const [nombreUsuario, setNombreUsuario] = useState([]);
  const [contrasena, setContrasena] = useState([]);
  const [contrasenaRepite, setContrasenaRepite] = useState([]);
  const [permissions, setPermissions] = useState("");

  console.log(errors);

  useEffect(() => {
    getUsuarios().then((usuarios) => {
      setUsuarios(usuarios);
    });
    getPerfiles().then((perfiles) => {
      setPerfiles(perfiles);
    });
    getPermissions().then((permissions) => {
      setPermissions(permissions);
      if (
        !(
          permissions.length > 0 &&
          permissions.some((e) => e.id_section === sections.ADMINISTRACION)
        )
      ) {
        history.push("/bienvenido");
      }
    });
  }, []);

  return (
    <div>
      {permissions.length > 0 &&
        permissions.some((e) => e.id_section === sections.ADMINISTRACION) && (
          <div>
            <div className="mt-3">
              <div className="row align-items-center">
                <div className="col-6">
                  <h1>Usuarios</h1>
                </div>
                <div className="col-6 text-end">
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    className="btn btn-warning"
                    id="myBtn"
                  >
                    Crear usuario
                  </button>
                </div>
              </div>
            </div>
            <div className="my-5">
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th style={{ width: 0 + "%" }}>#</th>
                    <th className="col-10">Usuario</th>
                    {/* <th className="col-1">¿Habilitado?</th> */}
                  </tr>
                </thead>
                <tbody>
                  {usuarios.length > 0
                    ? usuarios.map((usuario) => {
                        return (
                          <tr key={usuario.usu_id}>
                            <td>{usuario.usu_id}</td>
                            <td>{usuario.usu_username}</td>
                            {/* <td className="">
                              <div className="form-check form-switch d-flex justify-content-center">
                                <input
                                  checked={usuario.usu_status === "1"}
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  onClick={(e) => {
                                    //   changeStatusUsuario([
                                    //     { id: usuario.age_id },
                                    //   ]).then(() => {
                                    //     getUsuarios().then((usuarios) => {
                                    //       setUsuarios(usuarios);
                                    //     });
                                    //   });
                                  }}
                                />
                              </div>
                            </td> */}
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        )}

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Nuevo usuario
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="form-group mt-2">
                <label htmlFor="fechaAgenda">Nombre usuario</label>
                <input
                  className="form-control"
                  type="text"
                  id="nombreUsuario"
                  onChange={(e) => {
                    setNombreUsuario(e.target.value);
                  }}
                />
              </div>
              <div className="form-group mt-2">
                <label htmlFor="fechaAgenda">Contraseña</label>
                <input
                  className="form-control"
                  type="password"
                  id="contrasena"
                  onChange={(e) => {
                    setContrasena(e.target.value);
                  }}
                />
              </div>

              <div className="form-group mt-2">
                <label htmlFor="fechaAgenda">Repita contraseña</label>
                <input
                  className="form-control"
                  type="password"
                  id="contrasenaRepite"
                  onChange={(e) => {
                    setContrasenaRepite(e.target.value);
                  }}
                />
              </div>

              <div className="form-group mt-2">
                <label htmlFor="limite">Perfil:</label>
                <div className="form-group">
                  {perfiles.length > 0 ? (
                    <select
                      id="perfil"
                      className="form-select"
                      onChange={(e) => {
                        setPerfil(e.target.value);
                      }}
                    >
                      {perfiles.map((perfil, index) => (
                        <option key={perfil.id} defaultValue={perfil.perfil}>
                          {perfil.descripcion}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <select className="form-select">
                      <option>No disponible</option>
                    </select>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  if (contrasena === contrasenaRepite) {
                    let usuario = {
                      usuario: nombreUsuario,
                      contrasena: contrasena,
                      perfil: perfil,
                    };
                    crearUsuario(usuario).then(() => {
                      alert("Se creo correctamente.");
                      getUsuarios().then((usuarios) => {
                        setUsuarios(usuarios);
                      });
                    });
                  } else {
                    alert("Contraseñas no coinciden.");
                  }
                }}
              >
                Crear
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usuarios;
